export const ErrorTag = {
  // Order Service Errors
  OrderTokenGetError: '@app/OrderToken/OrderTokenGetError',
  OrderTokenSetError: '@app/OrderToken/OrderTokenSetError',
  OrderTokenNotFoundError: '@app/PaymentRequest/OrderTokenNotFoundError',
  OrderShipmentGetError: '@app/OrderShipment/OrderShipmentGetError',
  OrderShipmentSetError: '@app/OrderShipment/OrderShipmentSetError',
  CreateOrderDidNotReturnToken: '@app/OrderService/CreateOrderDidNotReturnToken',
  TokenRemovedRetryError: '@app/OrderService/TokenRemovedRetryError',

  // Auth Service Errors
  AuthTokenGetError: '@app/AuthToken/AuthTokenGetError',
  AuthTokenSetError: '@app/AuthToken/AuthTokenSetError',
  AuthTokenRefreshError: '@app/AuthToken/AuthTokenRefreshError',
  JwtDecodeError: '@app/AuthToken/JwtDecodeError',

  // Cookie Service Errors
  CookieGetError: '@app/CookiesStore/CookieGetError',
  CookieSetError: '@app/CookiesStore/CookieSetError',
  CookieRemoveError: '@app/CookiesStore/CookieRemoveError',
  CookieAccessError: '@app/CookiesStore/CookieAccessError',

  // API Client Errors
  ApiError: '@app/ApiClient/ApiError',
  UrlParsingError: '@app/ApiClient/UrlParsingError',
  UrlBuildError: '@app/ApiClient/UrlBuildError',
  RequestBuildError: '@app/ApiClient/RequestBuildError',
  RequestExecutionError: '@app/ApiClient/RequestExecutionError',
  ResponseHandlingError: '@app/ApiClient/ResponseHandlingError',

  // Router Errors
  MissingIdSegmentError: '@app/Router/MissingIdSegmentError',
  XRouteNotFoundError: '@app/Router/XRouteNotFoundError',

  // Pagination Errors
  UrlParseError: '@app/Pagination/UrlParseError',
  PageParamNotFoundError: '@app/Pagination/PageParamNotFoundError',
  InvalidPageNumberError: '@app/Pagination/InvalidPageNumberError',

  // GTM Errors
  GtmSendError: '@app/Gtm/GtmSendError',

  // Order Violation Errors (Sylius API 422 responses)
  PaymentMethodEligibilityError: '@app/OrderViolation/PaymentMethodEligibilityError',
  ProductEligibilityError: '@app/OrderViolation/ProductEligibilityError',
  ShippingMethodEligibilityError: '@app/OrderViolation/ShippingMethodEligibilityError',
  ShippingMethodNotAvailableError: '@app/OrderViolation/ShippingMethodNotAvailableError',
  AddressRequirementError: '@app/OrderViolation/AddressRequirementError',
  CurrencyCodeNotValidError: '@app/OrderViolation/CurrencyCodeNotValidError',
  CartItemNotAvailableError: '@app/OrderViolation/CartItemNotAvailableError',
  CartItemInsufficientStockError: '@app/OrderViolation/CartItemInsufficientStockError',
  CartItemQuantityNotInRangeError: '@app/OrderViolation/CartItemQuantityNotInRangeError',
  CartItemVariantNotAvailableError: '@app/OrderViolation/CartItemVariantNotAvailableError',
  MaxOrderableInCartError: '@app/OrderViolation/MaxOrderableInCartError',
  OrderNotEmptyError: '@app/OrderViolation/OrderNotEmptyError',
  ProductVariantCodeNotExistError: '@app/OrderViolation/ProductVariantCodeNotExistError',
  ProductVariantNotExistError: '@app/OrderViolation/ProductVariantNotExistError',
  ProductVariantNotSufficientError: '@app/OrderViolation/ProductVariantNotSufficientError',
  OrderInvalidStateTransitionError: '@app/OrderViolation/OrderInvalidStateTransitionError',
  OrderCartItemsImmutableError: '@app/OrderViolation/OrderCartItemsImmutableError',
  UnknownViolationError: '@app/OrderViolation/UnknownViolationError',

  // Packeta Widget Errors
  PacketaWidgetNotLoadedError: '@app/PacketaWidget/PacketaWidgetNotLoadedError',
  PacketaWidgetCancelledError: '@app/PacketaWidget/PacketaWidgetCancelledError',
  PacketaWidgetScriptLoadError: '@app/PacketaWidget/PacketaWidgetScriptLoadError',
  PacketaWidgetPayloadError: '@app/PacketaWidget/PacketaWidgetPayloadError',

  // Balíkovna Widget Errors
  BalikovnaWidgetNotLoadedError: '@app/BalikovnaWidget/BalikovnaWidgetNotLoadedError',
  BalikovnaWidgetCancelledError: '@app/BalikovnaWidget/BalikovnaWidgetCancelledError',
  BalikovnaWidgetPayloadError: '@app/BalikovnaWidget/BalikovnaWidgetPayloadError',

  // PPL Widget Errors
  PplWidgetNotLoadedError: '@app/PplWidget/PplWidgetNotLoadedError',
  PplWidgetCancelledError: '@app/PplWidget/PplWidgetCancelledError',
  PplWidgetAssetLoadError: '@app/PplWidget/PplWidgetAssetLoadError',
  PplWidgetPayloadError: '@app/PplWidget/PplWidgetPayloadError',
  PplWidgetRuntimeError: '@app/PplWidget/PplWidgetRuntimeError',

  // Slovak Post Widget Errors
  SlovakPostWidgetNotLoadedError: '@app/SlovakPostWidget/SlovakPostWidgetNotLoadedError',
  SlovakPostWidgetCancelledError: '@app/SlovakPostWidget/SlovakPostWidgetCancelledError',
  SlovakPostWidgetScriptLoadError: '@app/SlovakPostWidget/SlovakPostWidgetScriptLoadError',
  SlovakPostWidgetPayloadError: '@app/SlovakPostWidget/SlovakPostWidgetPayloadError',

  // Lock Errors
  LockTimeoutError: '@app/RefreshLock/LockTimeoutError',
  LockAcquisitionError: '@app/RefreshLock/LockAcquisitionError',
} as const;
